export default "__VITE_ASSET__DdLb9pVS__"